const Buttons = function () {

  function init() {
    const buttons = document.querySelectorAll(['button.application.button.ic-up'])

    if (buttons.length) {
      window.addEventListener('click', event => {

        const target = event.target

        if (target.matches('button.application.button.ic-up')) {

          event.preventDefault()

          const parent = target.parentElement
          const rect = parent.getBoundingClientRect();
          const header = document.getElementsByClassName('header')[0]
          const scrollTop = rect.top + window.scrollY - (header.offsetHeight * 2)

          parent.removeAttribute('open')
          window.scrollTo({ top: scrollTop, behavior: 'smooth' })
        }
      })
    }
  }

  return {
    init
  }

}()

export default Buttons
